import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";
import { WHY_BUSINESS } from "../data/content";

export default function WhyChoose() {
  return (
    <section
      data-testid="why-choose-section"
      className="relative py-24 md:py-32 bg-white/50 border-y border-jo-primary/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <SectionHeader
          center
          label="Why Businesses Choose Us"
          title="Built on trust, driven by results"
          desc="Every engagement is backed by experience, precision and a genuine customer-first commitment."
        />

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {WHY_BUSINESS.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.CheckCircle;
            return (
              <Reveal key={item.title} delay={i * 0.06}>
                <motion.div
                  data-testid={`why-card-${i}`}
                  whileHover={{ y: -8 }}
                  transition={{ type: "spring", stiffness: 300, damping: 22 }}
                  className="group relative h-full rounded-3xl bg-white border border-jo-primary/8 p-7 overflow-hidden hover:shadow-xl hover:shadow-jo-primary/8 transition-shadow duration-400"
                >
                  <div className="absolute -top-10 -right-10 h-28 w-28 rounded-full bg-jo-accent/5 group-hover:bg-jo-highlight/10 transition-colors duration-500" />
                  <div className="relative">
                    <span className="inline-flex h-13 w-13 h-[52px] w-[52px] rounded-2xl bg-gradient-to-br from-jo-primary to-jo-accent items-center justify-center text-white shadow-lg shadow-jo-primary/20">
                      <Icon size={22} strokeWidth={1.75} />
                    </span>
                    <h3 className="mt-5 text-lg font-semibold text-jo-primary">{item.title}</h3>
                    <p className="mt-2 text-sm text-slate-600 font-light leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
